import { render, staticRenderFns } from "./HomeEventCard.vue?vue&type=template&id=3bd64a48&scoped=true&"
import script from "./HomeEventCard.vue?vue&type=script&lang=js&"
export * from "./HomeEventCard.vue?vue&type=script&lang=js&"
import style0 from "./HomeEventCard.vue?vue&type=style&index=0&id=3bd64a48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd64a48",
  null
  
)

export default component.exports